
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-awareness/investor-awareness",
      function () {
        return require("private-next-pages/investor-awareness/investor-awareness.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor-awareness/investor-awareness"])
      });
    }
  